module.exports = __webpack_public_path__ + "img/ИФ-1(А)-035-m.e1595908.png";